module.exports = __webpack_public_path__ + "img/key.ace4e87b.svg";